export const SERVICE_CONST = {
  GET_SERVICES: "GET_SERVICES",
  GET_SELECTED_SERVICE: "GET_SELECTED_SERVICE",
};
